import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MachineCard, MachineCardImg } from "../Investment/Investment.styled";
import {
  BuyButton,
  BuyCard,
  BuyMinerContainer,
  MachineBuyValueText,
} from "./BuyMiner.styled";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { buyMiner } from "../../feature/minersOwned/MinersOwnedActions";
import { FormError } from "../Auth.styled";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import { getUserBalance } from "../../feature/wallet/WalletActions";
import ReactLoading from "react-loading";
import SuccessPage from "../SuccessPage/SuccessPage";

const BuyMiner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bought, setBought] = useState(false);
  const { balance } = useSelector((state) => state.wallet);
  const { user } = useSelector((state) => state.user);
  const { inputError } = useSelector((state) => state.inputError);
  const { loading } = useSelector((state) => state.minersOwned);
  const selectedMachine =
    location.state !== null && location.state.selectedMachine;
  const qty = location.state !== null && location.state.qty;

  const onSubmit = () => {
    dispatch(
      buyMiner({ user: user.id, machine: selectedMachine.id, quantity: qty })
    )
      .unwrap()
      .then((res) => setBought(true));
  };

  const initialValues = {};

  const validationSchema = Yup.object({});

  const formik = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    location.state === null && navigate("/investment");
  }, [location.state, navigate]);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserBalance({ user: user }));
    dispatch(clearInputError());
  }, [dispatch, user]);

  return (
    <>
      {bought ? (
        <SuccessPage
          message="Miner Purchased"
          links={[
            { link: "/investment", name: "Investment" },
            { link: "/miners-owned", name: "Miners" },
          ]}
        />
      ) : (
        <BuyMinerContainer>
          <form onSubmit={formik.handleSubmit}>
            <MachineCard style={{ flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div>
                  <MachineCardImg alt="machine1" src={selectedMachine.image} />
                  <MachineBuyValueText>
                    Revenue:{" "}
                    <span style={{ marginBottom: "5px" }}>
                      {selectedMachine.daily_profit} TRX
                    </span>
                  </MachineBuyValueText>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <div>{selectedMachine.name}</div>
                    <MachineBuyValueText style={{ marginBottom: "5px" }}>
                      {selectedMachine.price} TRX
                    </MachineBuyValueText>
                  </div>
                  <div>
                    <div>1 year profit</div>
                    <MachineBuyValueText style={{ marginBottom: "5px" }}>
                      {(selectedMachine.daily_profit * 365).toFixed(2)} TRX
                    </MachineBuyValueText>
                  </div>
                  <div>
                    <div>30 days profit</div>
                    <MachineBuyValueText style={{ marginBottom: "5px" }}>
                      {(selectedMachine.daily_profit * 30).toFixed(2)} TRX
                    </MachineBuyValueText>
                  </div>
                  <div>
                    <div>Earning cycle</div>
                    <MachineBuyValueText style={{ marginBottom: "5px" }}>
                      {selectedMachine.earning_sequence} hour
                    </MachineBuyValueText>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "20px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  QTY: {qty}
                </div>
              </div>
            </MachineCard>
            <BuyCard>
              <span>Available Balance:</span> <span>{balance} TRX</span>
            </BuyCard>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #7B36EE",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  Quantity: {qty}
                </div>
              </div>
              <BuyButton type="submit" disabled={loading}>
                {loading ? (
                  <ReactLoading
                    type={"spinningBubbles"}
                    height={"20px"}
                    width={"20px"}
                  />
                ) : (
                  "Buy"
                )}
              </BuyButton>
            </div>

            <FormError>
              {inputError !== undefined
                ? inputError[0]
                  ? inputError[0]
                  : null
                : null}
            </FormError>
          </form>
        </BuyMinerContainer>
      )}
    </>
  );
};

export default BuyMiner;
